var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 0C6.04935 0 0 6.04935 0 13.5C0 20.9507 6.04935 27 13.5 27C20.9507 27 27 20.9507 27 13.5C27 6.04935 20.9507 0 13.5 0ZM13.5 2.7C19.4603 2.7 24.3 7.53975 24.3 13.5C24.3 19.4603 19.4603 24.3 13.5 24.3C7.5384 24.3 2.7 19.4603 2.7 13.5C2.7 7.53975 7.5384 2.7 13.5 2.7ZM11.1132 15.4089L17.7957 8.7264C18.3222 8.1999 19.1781 8.1999 19.7046 8.7264C20.2311 9.25425 20.2311 10.1088 19.7046 10.6366L12.0676 18.2736C11.5411 18.8001 10.6853 18.8001 10.1588 18.2736L7.2954 15.4089C6.76755 14.8824 6.76755 14.0265 7.2954 13.5C7.8219 12.9735 8.67645 12.9735 9.2043 13.5L11.1132 15.4089Z",
    fill: "#3EB973"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.0c0fb2d31aea5a68e29b5f0a5c9327c4.svg";
export { ForwardRef as ReactComponent };